import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatGridListModule } from '@angular/material/grid-list';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { DetailsCommonsModule } from '@shared/modules/details-commons/details-commons.module';
import { GeneralCommonsModule } from '@shared/modules/general-commons/general-commons.module';

import { SearchModule } from '../search/search.module';
import { UsersModule } from '../user/users.module';
import { PartnerDetailsPageComponent } from './components/partner-details-page/partner-details-page.component';
import { PartnerDetailsComponent } from './components/partner-details/partner-details.component';
import { PartnerSearchPageComponent } from './components/partner-search-page/partner-search-page.component';
import { PartnerSearchComponent } from './components/partner-search/partner-search.component';
import { PartnersRoutingModule } from './partners-routing.module';

@NgModule({
  imports: [
    CommonModule,
    DetailsCommonsModule,
    GeneralCommonsModule,
    MatGridListModule,
    PartnersRoutingModule,
    ReactiveFormsModule,
    RouterModule,
    SearchModule,
    TranslateModule.forChild(),
    UsersModule,
    PartnerSearchPageComponent,
    PartnerDetailsComponent,
    PartnerDetailsPageComponent,
    PartnerSearchComponent
  ],
  exports: []
})
export class PartnerModule {}
